import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import API_URL from '../api';
import { useToast } from '../contexts/ToastContext';
import './StudentRegister.css';

const StudentRegister = ({ onLogin }) => {
  const { hash } = useParams();
  const navigate = useNavigate();
  const { success, error: toastError } = useToast();

  const [inviteInfo, setInviteInfo] = useState(null);
  const [checkingInvite, setCheckingInvite] = useState(true);
  const [inviteError, setInviteError] = useState('');
  const [departments, setDepartments] = useState([]);

  const [formData, setFormData] = useState({
    studentName: '',
    studentLastName: '',
    username: '',
    password: '',
    confirmPassword: '',
    position: 'waiter'
  });

  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const validateInviteAndLoadDepts = async () => {
      try {
        const [inviteRes, deptsRes] = await Promise.all([
          axios.get(`${API_URL}/invites/${hash}`),
          axios.get(`${API_URL}/departments`)
        ]);
        setInviteInfo(inviteRes.data);
        setDepartments(deptsRes.data);
        const defaultPos = inviteRes.data.position || (deptsRes.data.length > 0 ? deptsRes.data[0].key : 'waiter');
        setFormData(prev => ({ ...prev, position: defaultPos }));
      } catch (err) {
        const msg = err.response?.data?.error || 'Недійсне або застаріле посилання для реєстрації';
        setInviteError(msg);
        toastError(msg);
      } finally {
        setCheckingInvite(false);
      }
    };
    validateInviteAndLoadDepts();
  }, [hash, toastError]);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (formData.password !== formData.confirmPassword) {
      setError('Паролі не співпадають');
      return;
    }

    if (formData.password.length < 6) {
      setError('Пароль має бути не менше 6 символів');
      return;
    }

    setLoading(true);
    try {
      const res = await axios.post(`${API_URL}/auth/register-student`, {
        username: formData.username,
        password: formData.password,
        studentName: formData.studentName,
        studentLastName: formData.studentLastName,
        inviteHash: hash,
        position: formData.position
      });

      const { token, user } = res.data;
      localStorage.setItem('token', token);
      localStorage.setItem('user', JSON.stringify(user));
      onLogin(token, user);
      success(`Вітаємо у ServIQ, ${user.username}! Акаунт створено.`);
      navigate('/');
    } catch (err) {
      const errorMsg = err.response?.data?.error || 'Помилка під час реєстрації';
      setError(errorMsg);
      toastError(errorMsg);
    } finally {
      setLoading(false);
    }
  };

  if (checkingInvite) {
    return (
      <div className="register-container">
        <div className="register-card loading-card">
          <div className="spinner"></div>
          <p>Перевірка посилання для запрошення...</p>
        </div>
      </div>
    );
  }

  if (inviteError) {
    return (
      <div className="register-container">
        <div className="register-card error-card">
          <div className="error-icon">❌</div>
          <h2>Помилка запрошення</h2>
          <p>{inviteError}</p>
          <button className="btn-back" onClick={() => navigate('/')}>На головну</button>
        </div>
      </div>
    );
  }

  const isFunPlanet = inviteInfo?.city && (
    inviteInfo.city.toLowerCase().replace(/[\s-]/g, '') === 'фанпланет' ||
    inviteInfo.city.toLowerCase().replace(/[\s-]/g, '') === 'funplanet' ||
    inviteInfo.city.toLowerCase().replace(/[\s-]/g, '') === 'Funplanet' ||
    inviteInfo.city.toLowerCase().replace(/[\s-]/g, '') === 'FunPlanet' ||
    inviteInfo.city.toLowerCase().replace(/[\s-]/g, '') === 'ФанПланет' ||
    inviteInfo.city.toLowerCase().replace(/[\s-]/g, '') === 'FUNPLANET' ||
    inviteInfo.city.toLowerCase().replace(/[\s-]/g, '') === 'fun-planet' ||
    inviteInfo.city.toLowerCase().replace(/[\s-]/g, '') === 'Fun-planet' ||
    inviteInfo.city.toLowerCase().replace(/[\s-]/g, '') === 'Fun-Planet' ||
    inviteInfo.city.toLowerCase().replace(/[\s-]/g, '') === 'Фан-Планет' ||
    inviteInfo.city.toLowerCase().replace(/[\s-]/g, '') === 'FUN-PLANET' ||
    inviteInfo.city.toLowerCase().replace(/[\s-]/g, '') === 'fun-planet' ||
    inviteInfo.city.toLowerCase().replace(/[\s-]/g, '') === 'Fun-planet' ||
    inviteInfo.city.toLowerCase().replace(/[\s-]/g, '') === 'Fun-Planet' ||
    inviteInfo.city.toLowerCase().replace(/[\s-]/g, '') === 'Фан-Планет' ||
    inviteInfo.city.toLowerCase().replace(/[\s-]/g, '') === 'FUN-PLANET' ||
    inviteInfo.city.toLowerCase().replace(/[\s-]/g, '') === 'Fun-planet' ||
    inviteInfo.city.toLowerCase().replace(/[\s-]/g, '') === 'Fun-Planet' ||
    inviteInfo.city.toLowerCase().replace(/[\s-]/g, '') === 'Фан-Планет' ||
    inviteInfo.city.toLowerCase().replace(/[\s-]/g, '') === 'FUN-PLANET' ||
    inviteInfo.city.toLowerCase().replace(/[\s-]/g, '') === 'fun-planet' ||
    inviteInfo.city.toLowerCase().replace(/[\s-]/g, '') === 'Fun-planet' ||
    inviteInfo.city.toLowerCase().replace(/[\s-]/g, '') === 'Fun-Planet' ||
    inviteInfo.city.toLowerCase().replace(/[\s-]/g, '') === 'Фан-Планет' ||
    inviteInfo.city.toLowerCase().replace(/[\s-]/g, '') === 'FUN-PLANET' ||
    inviteInfo.city.toLowerCase().replace(/[\s-]/g, '') === 'fun-planet' ||
    inviteInfo.city.toLowerCase().replace(/[\s-]/g, '') === 'Fun-planet' ||
    inviteInfo.city.toLowerCase().replace(/[\s-]/g, '') === 'Fun-Planet' ||
    inviteInfo.city.toLowerCase().replace(/[\s-]/g, '') === 'Фан-Планет' ||
    inviteInfo.city.toLowerCase().replace(/[\s-]/g, '') === 'FUN-PLANET' ||
    inviteInfo.city.toLowerCase().replace(/[\s-]/g, '') === 'fun-planet' ||
    inviteInfo.city.toLowerCase().replace(/[\s-]/g, '') === 'Fun-planet' ||
    inviteInfo.city.toLowerCase().replace(/[\s-]/g, '') === 'Fun-Planet' ||
    inviteInfo.city.toLowerCase().replace(/[\s-]/g, '') === 'Фан-Планет' ||
    inviteInfo.city.toLowerCase().replace(/[\s-]/g, '') === 'FUN-PLANET' ||
    inviteInfo.city.toLowerCase().replace(/[\s-]/g, '') === 'fun-planet' ||
    inviteInfo.city.toLowerCase().replace(/[\s-]/g, '') === 'Fun-planet' ||
    inviteInfo.city.toLowerCase().replace(/[\s-]/g, '') === 'Fun-Planet' ||
    inviteInfo.city.toLowerCase().replace(/[\s-]/g, '') === 'Фан-Планет' ||
    inviteInfo.city.toLowerCase().replace(/[\s-]/g, '') === 'FUN-PLANET' ||
    inviteInfo.city.toLowerCase().replace(/[\s-]/g, '') === 'fun-planet' ||
    inviteInfo.city.toLowerCase().replace(/[\s-]/g, '') === 'Fun-planet' ||
    inviteInfo.city.toLowerCase().replace(/[\s-]/g, '') === 'Fun-Planet' ||
    inviteInfo.city.toLowerCase().replace(/[\s-]/g, '') === 'Фан-Планет' ||
    inviteInfo.city.toLowerCase().replace(/[\s-]/g, '') === 'FUN-PLANET' ||
    inviteInfo.city.toLowerCase().replace(/[\s-]/g, '') === 'fun-planet' ||
    inviteInfo.city.toLowerCase().replace(/[\s-]/g, '') === 'Fun-planet' ||
    inviteInfo.city.toLowerCase().replace(/[\s-]/g, '') === 'Fun-Planet' ||
    inviteInfo.city.toLowerCase().replace(/[\s-]/g, '') === 'Фан-Планет' ||
    inviteInfo.city.toLowerCase().replace(/[\s-]/g, '') === 'FUN-PLANET' ||
    inviteInfo.city.toLowerCase().replace(/[\s-]/g, '') === 'fun-planet' ||
    inviteInfo.city.toLowerCase().replace(/[\s-]/g, '') === 'Fun-planet' ||
    inviteInfo.city.toLowerCase().replace(/[\s-]/g, '') === 'Fun-Planet' ||
    inviteInfo.city.toLowerCase().replace(/[\s-]/g, '') === 'Фан-Планет' ||
    inviteInfo.city.toLowerCase().replace(/[\s-]/g, '') === 'FUN-PLANET' ||
    inviteInfo.city.toLowerCase().replace(/[\s-]/g, '') === 'fun-planet' ||
    inviteInfo.city.toLowerCase().replace(/[\s-]/g, '') === 'Fun-planet' ||
    inviteInfo.city.toLowerCase().replace(/[\s-]/g, '') === 'Fun-Planet' ||
    inviteInfo.city.toLowerCase().replace(/[\s-]/g, '') === 'Фан-Планет' ||
    inviteInfo.city.toLowerCase().replace(/[\s-]/g, '') === 'FUN-PLANET' ||
    inviteInfo.city.toLowerCase().replace(/[\s-]/g, '') === 'fun-planet' ||
    inviteInfo.city.toLowerCase().replace(/[\s-]/g, '') === 'Fun-planet' ||
    inviteInfo.city.toLowerCase().replace(/[\s-]/g, '') === 'Fun-Planet' ||
    inviteInfo.city.toLowerCase().replace(/[\s-]/g, '') === 'Фан-Планет' ||
    inviteInfo.city.toLowerCase().replace(/[\s-]/g, '') === 'FUN-PLANET' ||
    inviteInfo.city.toLowerCase().replace(/[\s-]/g, '') === 'fun-planet' ||
    inviteInfo.city.toLowerCase().replace(/[\s-]/g, '') === 'Fun-planet' ||
    inviteInfo.city.toLowerCase().replace(/[\s-]/g, '') === 'Fun-Planet' ||
    inviteInfo.city.toLowerCase().replace(/[\s-]/g, '') === 'Фан-Планет' ||
    inviteInfo.city.toLowerCase().replace(/[\s-]/g, '') === 'FUN-PLANET' ||
    inviteInfo.city.toLowerCase().replace(/[\s-]/g, '') === 'fun-planet' ||
    inviteInfo.city.toLowerCase().replace(/[\s-]/g, '') === 'Fun-planet' ||
    inviteInfo.city.toLowerCase().replace(/[\s-]/g, '') === 'Fun-Planet' ||
    inviteInfo.city.toLowerCase().replace(/[\s-]/g, '') === 'Фан-Планет' ||
    inviteInfo.city.toLowerCase().replace(/[\s-]/g, '') === 'FUN-PLANET'
  );

  return (
    <div className="register-container">
      <div className="register-card">
        <div className="register-logo">
          <img
            src={isFunPlanet ? "/FUN-planet-1.png" : "/km-logo.png"}
            alt={isFunPlanet ? "Фан Планет" : "Країна Мрій"}
            className="register-logo-img"
          />
          <h2>Реєстрація гравця</h2>
          {inviteInfo && (
            <div className="invite-tag">
              Локація: <strong>{inviteInfo.city}</strong> {inviteInfo.platform && `(${inviteInfo.platform})`}
            </div>
          )}
        </div>

        <form onSubmit={handleSubmit} className="register-form">
          {error && <div className="error-banner">{error}</div>}

          <div className="form-row">
            <div className="form-group">
              <label htmlFor="studentName">Ім'я</label>
              <input
                id="studentName"
                type="text"
                name="studentName"
                value={formData.studentName}
                onChange={handleChange}
                placeholder="Введіть ім'я"
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="studentLastName">Прізвище</label>
              <input
                id="studentLastName"
                type="text"
                name="studentLastName"
                value={formData.studentLastName}
                onChange={handleChange}
                placeholder="Введіть прізвище"
                required
              />
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="username">Логін (Email або Нікнейм)</label>
            <input
              id="username"
              type="text"
              name="username"
              value={formData.username}
              onChange={handleChange}
              placeholder="Введіть логін для входу"
              required
            />
          </div>

          {!inviteInfo?.position && (
            <div className="form-group">
              <label htmlFor="position">Підрозділ / Посада</label>
              <select
                id="position"
                name="position"
                value={formData.position}
                onChange={handleChange}
                required
                className="sm-position-select"
                style={{
                  background: 'rgba(255, 255, 255, 0.03)',
                  border: '1px solid var(--border)',
                  color: 'var(--text-main)',
                  padding: '0.75rem 1rem',
                  borderRadius: '8px',
                  fontSize: '1rem',
                  outline: 'none',
                  cursor: 'pointer'
                }}
              >
                {departments.length === 0 ? (
                  <>
                    <option value="waiter">🧑‍🍳 Офіціант</option>
                    <option value="banquet_manager">🥂 Банкетний менеджер</option>
                    <option value="administrator">💼 Адміністратор</option>
                  </>
                ) : (
                  departments.map(d => (
                    <option key={d._id} value={d.key}>{d.name}</option>
                  ))
                )}
              </select>
            </div>
          )}

          <div className="form-group">
            <label htmlFor="password">Пароль</label>
            <input
              id="password"
              type="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              placeholder="Створіть пароль (мін. 6 символів)"
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="confirmPassword">Підтвердження паролю</label>
            <input
              id="confirmPassword"
              type="password"
              name="confirmPassword"
              value={formData.confirmPassword}
              onChange={handleChange}
              placeholder="Повторіть ваш пароль"
              required
            />
          </div>

          <button type="submit" className="btn-register" disabled={loading}>
            {loading ? 'Створення акаунту...' : 'Створити акаунт та увійти'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default StudentRegister;
